/**
 * @flow
 * @relayHash 116f642ac1cb972e6d550c5044d65ed6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type CreateCheckPaymentMethodInput = {
  clientMutationId?: ?string,
  user_id: string,
  address: string,
  pay_to: string,
  enabled: boolean,
  invoice_id?: ?string,
};
export type AcceptedPaymentMethods_CreateCheckPaymentMethodMutationVariables = {|
  input: CreateCheckPaymentMethodInput
|};
export type AcceptedPaymentMethods_CreateCheckPaymentMethodMutationResponse = {|
  +createCheckPaymentMethod: ?{|
    +check_payment_method: ?{|
      +id: string,
      +address: ?string,
      +enabled: ?boolean,
      +pay_to: ?string,
    |},
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |},
    +user: ?{|
      +payment_methods: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?({|
            +__typename: "CheckPaymentMethod",
            +id: string,
            +address: ?string,
            +enabled: ?boolean,
            +pay_to: ?string,
          |} | {|
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            +__typename: "%other"
          |})
        |}>
      |}
    |},
  |}
|};
export type AcceptedPaymentMethods_CreateCheckPaymentMethodMutation = {|
  variables: AcceptedPaymentMethods_CreateCheckPaymentMethodMutationVariables,
  response: AcceptedPaymentMethods_CreateCheckPaymentMethodMutationResponse,
|};
*/


/*
mutation AcceptedPaymentMethods_CreateCheckPaymentMethodMutation(
  $input: CreateCheckPaymentMethodInput!
) {
  createCheckPaymentMethod(input: $input) {
    check_payment_method {
      id
      address
      enabled
      pay_to
    }
    invoice {
      ...InvoiceContainer_node
      id
    }
    user {
      payment_methods {
        edges {
          node {
            __typename
            ... on CheckPaymentMethod {
              __typename
              id
              address
              enabled
              pay_to
            }
            ... on Node {
              id
            }
          }
        }
      }
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateCheckPaymentMethodInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateCheckPaymentMethodInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "address",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "enabled",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pay_to",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "check_payment_method",
  "storageKey": null,
  "args": null,
  "concreteType": "CheckPaymentMethod",
  "plural": false,
  "selections": [
    v2,
    v3,
    v4,
    v5
  ]
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "instructions",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount_cents",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount_currency",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v14 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
],
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "paid_at",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "refunds",
  "storageKey": null,
  "args": null,
  "concreteType": "RefundConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Refund",
          "plural": false,
          "selections": [
            v2,
            v11,
            v12,
            v15,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "refunded_at",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
},
v21 = [
  v7,
  v11,
  v12,
  v18,
  v15,
  v13,
  v19,
  v20
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "AcceptedPaymentMethods_CreateCheckPaymentMethodMutation",
  "id": null,
  "text": "mutation AcceptedPaymentMethods_CreateCheckPaymentMethodMutation(\n  $input: CreateCheckPaymentMethodInput!\n) {\n  createCheckPaymentMethod(input: $input) {\n    check_payment_method {\n      id\n      address\n      enabled\n      pay_to\n    }\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n    user {\n      payment_methods {\n        edges {\n          node {\n            __typename\n            ... on CheckPaymentMethod {\n              __typename\n              id\n              address\n              enabled\n              pay_to\n            }\n            ... on Node {\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AcceptedPaymentMethods_CreateCheckPaymentMethodMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createCheckPaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateCheckPaymentMethodPayload",
        "plural": false,
        "selections": [
          v6,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice",
            "storageKey": null,
            "args": null,
            "concreteType": "Invoice",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "InvoiceContainer_node",
                "args": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "payment_methods",
                "storageKey": null,
                "args": null,
                "concreteType": "PaymentMethodConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PaymentMethodEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "type": "CheckPaymentMethod",
                            "selections": [
                              v7,
                              v2,
                              v3,
                              v4,
                              v5
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "AcceptedPaymentMethods_CreateCheckPaymentMethodMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createCheckPaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateCheckPaymentMethodPayload",
        "plural": false,
        "selections": [
          v6,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice",
            "storageKey": null,
            "args": null,
            "concreteType": "Invoice",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "down_payment_currency",
                "args": null,
                "storageKey": null
              },
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "can_edit",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "can_email",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "share_token",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "brand_logo_url",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "brand_header",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_first_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_last_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_company_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_email",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_phone",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_address",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "deletable",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "down_payment_cents",
                "args": null,
                "storageKey": null
              },
              v8,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "down_payment_distribution_type",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "down_payment_due_at",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "down_payment_percent",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "down_payment_status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "number",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "pplan_distribution_type",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "total_cents",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "total_paid_cents",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "accepted_payment_methods",
                "storageKey": null,
                "args": null,
                "concreteType": "PaymentMethodConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PaymentMethodEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          v7,
                          v2,
                          {
                            "kind": "InlineFragment",
                            "type": "SquarePaymentMethod",
                            "selections": [
                              v4,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "application_id",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "location_id",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "location_name",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "CustomPaymentMethod",
                            "selections": [
                              v4,
                              v9,
                              v10
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "CheckPaymentMethod",
                            "selections": [
                              v3,
                              v4,
                              v5
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "CashPaymentMethod",
                            "selections": [
                              v4,
                              v10
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "i_pplan_items",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItemConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "IPplanItemEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "IPplanItem",
                        "plural": false,
                        "selections": [
                          v11,
                          v12,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "due_at",
                            "args": null,
                            "storageKey": null
                          },
                          v2,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "locked",
                            "args": null,
                            "storageKey": null
                          },
                          v13
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "invoice_event_segments",
                "storageKey": "invoice_event_segments(first:99999)",
                "args": v14,
                "concreteType": "InvoiceEventSegmentConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InvoiceEventSegmentEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "InvoiceEventSegment",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "line1",
                            "args": null,
                            "storageKey": null
                          },
                          v2,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "start_at",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "end_at",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "time_zone",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "all_day",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "location",
                            "args": null,
                            "storageKey": null
                          },
                          v8,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "line2",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "city",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "province",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "postal_code",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "room",
                            "args": null,
                            "storageKey": null
                          },
                          v15,
                          v7
                        ]
                      },
                      v16
                    ]
                  },
                  v17
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "invoice_event_segments",
                "args": v14,
                "handle": "connection",
                "key": "InvoiceContainer_invoice_event_segments",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "invoice_line_items",
                "storageKey": "invoice_line_items(first:99999)",
                "args": v14,
                "concreteType": "InvoiceLineItemConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InvoiceLineItemEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "InvoiceLineItem",
                        "plural": false,
                        "selections": [
                          v2,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "description",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "position",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "price_cents",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "price_currency",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "quantity",
                            "args": null,
                            "storageKey": null
                          },
                          v8,
                          v7
                        ]
                      },
                      v16
                    ]
                  },
                  v17
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "invoice_line_items",
                "args": v14,
                "handle": "connection",
                "key": "InvoiceContainer_invoice_line_items",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "payments",
                "storageKey": null,
                "args": null,
                "concreteType": "PaymentConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PaymentEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          v7,
                          v2,
                          {
                            "kind": "InlineFragment",
                            "type": "SquarePayment",
                            "selections": [
                              v7,
                              v11,
                              v12,
                              v18,
                              v19,
                              v20
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "CustomPayment",
                            "selections": [
                              v7,
                              v11,
                              v12,
                              v18,
                              v15,
                              v13,
                              v9,
                              v19,
                              v20
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "CheckPayment",
                            "selections": v21
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "CashPayment",
                            "selections": v21
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "workspaces",
                "storageKey": null,
                "args": null,
                "concreteType": "WorkspaceConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorkspaceEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Workspace",
                        "plural": false,
                        "selections": [
                          v2,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "event",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Event",
                            "plural": false,
                            "selections": [
                              v2,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "user_contacts",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "EventUserContactConnectionWithRole",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "EventUserContactEdge",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "UserContact",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "first_name",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "last_name",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "user_contact_emails",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "UserContactEmailConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "edges",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "UserContactEmailEdge",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "UserContactEmail",
                                                    "plural": false,
                                                    "selections": [
                                                      v3,
                                                      v2
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          v2
                                        ]
                                      },
                                      v2
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "payment_methods",
                "storageKey": null,
                "args": null,
                "concreteType": "PaymentMethodConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PaymentMethodEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          v7,
                          v2,
                          {
                            "kind": "InlineFragment",
                            "type": "CheckPaymentMethod",
                            "selections": [
                              v7,
                              v3,
                              v4,
                              v5
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              v2
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '689baa35bdee9a91373f3126a535df9c';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/App/PaymentMethods/__generated__/AcceptedPaymentMethods_CreateCheckPaymentMethodMutation.graphql.js